<form #f="ngForm">
    <div class="p-as-center p-mt-auto">
        <div class="p-grid">
            <div class="p-col-12">
                
                <div class="p-col-12 error-notify-text">
                    <app-validateform #forgotPassForm [formToValidate]="forgotPassFormValidate"></app-validateform>
                </div>
            </div>
        </div>
    </div>
    <div class="p-d-flex p-flex-column">
        <div class="p-as-center p-mb-auto">
            <div class="login-page pages-panel card" *ngIf="!requestSuccess; else completed">
                <div class="input-panel">
                    <div class="p-ml-3 p-mr-3">
                        <div class="p-mt-3" style="text-align:center !important"><h4>Password Assistance</h4></div>
                        <div class="p-mb-4" style="text-align:center !important">Enter the email associated with your NAIGlobal account, then click Continue. We'll send you a link to a page where you can easily create a new password.</div>
                        <div class="p-inputgroup p-mb-4">
                            <span class="p-inputgroup-addon">
                                <i class="pi pi-envelope"></i>
                            </span>
                            <span class="p-float-label">
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="forgotPassEmail"
                                       name="forgotPassEmail"
                                       requiredNoSpaceValidator
                                       data-display-name="Email" />
                                <label for="inputgroup">Email*</label>
                            </span>
                        </div>
                        <button pButton (click)="forgotPasswordProcess()" class="fullwidthbtn p-mb-2" label="SUBMIT"></button>
                        <div class="p-mb-3 p-mt-1" style="text-align:left !important;margin-left:1rem;">
                            <p-button class="p-mb-2" label="Return to login" styleClass="p-button-link" routerLink="/login"></p-button>
                        </div>
                    </div>                   
                </div>
            </div>
            <ng-template #completed>
                <div class="p-mt-3" style="text-align:center !important"><h4>We've sent you an email to reset your password</h4></div>
                You will receive an email from us in the next few minutes. Click on the link in the email to change your password.
                If you don't see an email from us in your inbox, please check your junk mail folder as it may have been mistakenly categorized as spam or try a different email address.
            </ng-template>
        </div>
    </div>
</form>
